import { ComponentType } from '../types';
import { AbstractComponentBuilder } from './AbstractComponentBuilder';
export class TextInputComponentBuilder extends AbstractComponentBuilder {
    constructor(id) {
        super(id, ComponentType.TextInput);
    }
    isValid() {
        return this.createValidationResponse()
            .withParentValidation(super.isValid())
            .validate();
    }
}
//# sourceMappingURL=TextInputComponentBuilder.js.map